import React, { useContext, useEffect, useState } from 'react'
import { Chart } from 'primereact/chart';
import ChartDataLabels from 'chartjs-plugin-datalabels';

import Loader from '../../../Base/Components/Loader/Loader';
import Card from '../../../Base/Components/Card/Card';
// import { formatNumber } from '../../../Base/Services/TemplatesServices';
import { ConfigContext } from '../../../Base/Context/ConfigContext/ConfigContext';

import { colorSintetico, datalabelsLineTintoreria, getTitle } from '../../../utils/KPIs/productionUtils';
import { Button } from 'primereact/button';
import { getProduccionFechaMesTint, getProduccionFechaMesTintoreria } from '../../../API/Produccion/KPIs/KPIs';
import { colorCotton } from '../../../Styles/Colors';
import AgGrid from '../../../Base/Components/Tables/AgGrid/AgGrid';
import { Dialog } from 'primereact/dialog';
import MetasDiariasDialog from './MetasDiariasDialog'
import { formatNumber } from '../../../Base/Services/TemplatesServices';
import { baseLang } from '../../../Base/Lang/BaseLang';
import { getLabel } from '../../../Base/Services/Language/LanguageService';

import DiarioMetasDiarias from './DiarioMetasDiarias'

const MetasSemanalesTintoreria = ({ date, kpiGerencia, getDatos, setShowMetasProduccion, altura = true }) => {

  const { config } = useContext(ConfigContext);

  const [loading, setLoading] = useState(false);
  const [tempo, setTempo] = useState([]);
  const [tempoP, setTempoP] = useState([]);
  const [showDialogDiario, setShowDialogDiario] = useState(false);
  const [semana, setSemana] = useState([]);
  const [chart, setChart] = useState({
    data: {},
    options: {}
  });

  let Mes = date.toLocaleString('es-ES', { month: 'long' })
  const monthName = Mes.charAt(0).toUpperCase() + Mes.slice(1);

  const colorTitle = getTitle(config);

  const getInfo = async () => {
    setLoading(true);
    const tempoReal = await getProduccionFechaMesTintoreria({ month: date.getMonth() + 1, year: date.getFullYear() });
    setTempo(tempoReal)

    const tempoProyeccion = await getProduccionFechaMesTint({ month: date.getMonth() + 1, year: date.getFullYear() });
    setTempoP(tempoProyeccion)

    const data = [...tempoReal]

    const semanaCorta = data.map(item => item.Semana);
    const semanas = data.map(item => `Week ${item.Semana}`);


    let totalCotton = []
    let totalSynthetic = []
    let totalK = []
    let totalKP = []


    tempoProyeccion.forEach((item) => {
      totalKP.push(item.TotalKgs);
    });

    tempoReal.forEach((item) => {
      console.log(item);
      // totalCotton.push(item.KgsTiC);
      // totalSynthetic.push(item.KgsTiS);
      totalK.push(item.KgsTotalTR);
    });

    let Mes = date.toLocaleString('es-ES', { month: 'long' })
    const monthName = Mes.charAt(0).toUpperCase() + Mes.slice(1);


    setChart({
      data: {
        labels: semanas,
        datasets: [
          //PROYECCION
          {
            type: "line",
            label: "Target",
            backgroundColor: '#363434ff',
            // backgroundColor: colorCotton,
            // borderColor: colorCotton,
            data: totalKP,
            borderDash: [5, 5],
          },
          //REAL
          {
            type: "bar",
            label: "Real",
            backgroundColor: '#aaa9a9ff',
            // backgroundColor: colorSintetico,
            // borderColor: colorSintetico,
            data: totalK,
            data2: totalK,
          },
        ],
      },
      options: {
        interaction: {
          intersect: false,
          mode: "index",
        },
        onClick: (event, elements) => {
          if (elements.length > 0) {
            const index = elements[0].index;
            const clickedWeek = semanaCorta[index];
            setShowDialogDiario(true)
            setSemana(clickedWeek)
          }
        },
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          title: {
            display: true,
            text: monthName + " / " + date.getFullYear(),
            color: getTitle(config),
            padding: {
              top: 15,
              bottom: 40,
            },
          },
          datalabels: datalabelsLineTintoreria,
          aspectRatio: 5 / 3,
          elements: {
            line: {
              fill: false,
              tension: 0.4,
            },
          },
          legend: {
            position: "bottom",
            labels: {
              color: colorTitle,
              font: {
                size: 11,
              },
            },
          },
        },
        scales: {
          x: {
            stacked: true,
            ticks: {
              color: colorTitle,
              minRotation: 0,
              maxRotation: 0,
            },
          },
          y: {
            ticks: {
              color: getTitle(config),
              callback: (val, index) => {
                return val > 0
                  ? formatNumber(val).replace(".00", "") + " Kg"
                  : "";
              },
            },
          },
        },
      },
    });
    setLoading(false);

  }

  const columns1 = [
    {
      // Customer
      field: 'IdCustomer',
      header: 'ID',
      className: 'XXsmall',
      Sumary: 'count',
      // hidden: userAuth?.IdRol === 1,
      frozen: 'frozen',
      alignFrozen: 'left',
    },
  ]

  const tableT = {
    Data: tempo,
    Columns: columns1
  };

  useEffect(() => {
    getInfo();
  }, [date, config])

  useEffect(() => {
    if (getDatos) {
      getInfo()
    }
  }, [getDatos])


  useEffect(() => {
    const intervalId = setInterval(() => {
      getInfo();
    }, 300000);

    return () => clearInterval(intervalId);
  }, [date, getDatos]);


  return (
    <div id='resumenProdTint' style={{ height: '100%' }}>
      <Loader loading={loading} querySelector={'#resumenProdTint'} />
      <Card
        style={{ height: altura ? '390px' : '500px' }}
        titulo={
          <div className='d-flex'>
            {/* <h4 className='mt-2'>Metas de Producción de Tintorería (Kg)</h4> */}
            <h4 className='mt-2'>{getLabel(baseLang, "prodTinto", config.language)}</h4>
            {kpiGerencia &&
              <Button
                className="p-button-text mx-2"
                style={{ zIndex: 1000 }}
                tooltip={getLabel(baseLang, "prodTintoTooltip", config.language)}
                icon='pi pi-eye'
                onClick={() => { setShowMetasProduccion(true); }}
              />
            }
          </div>
        }
        contenido={
          <div>
            <div className='col-12' style={{ flex: 1 }}>
              <Chart height={altura ? '350px' : '450px'} width='100%' type='bar' data={chart.data} options={chart.options} plugins={[ChartDataLabels]} />
            </div>

            {!kpiGerencia &&
              <div className='mt-2' style={{ ...(kpiGerencia ? { width: '600px' } : {}), height: '360px' }}>
                <AgGrid table={tableT} />
              </div>
            }

          </div>

        }
      />
      {/* <Dialog
        visible={showDialogDiario}
        onHide={() => { setShowDialogDiario(false) }}
        maximized={false}
        closeOnEscape={false}
        style={{ width: '80vw', height: '80vh', minHeight: '760px' }}
        resizable={false}
      >
        <div className='salesAnual' style={{ width: '100%', overflow: 'hidden', height: '100%' }}>
          <MetasDiariasDialog semana={semana} setSemana={setSemana} date={date} />
        </div>
      </Dialog> */}
      {/* <ResumenVentasAnual kpiGerencia={false} date={fecha} getDatos={getInfo} altura={true} /> */}
      <DiarioMetasDiarias
        dialogMetas={showDialogDiario}
        onHide={() => setShowDialogDiario(false)}
        semana={semana}
        setSemana={setSemana}
        date={date}
      />
    </div>
  );
};

export default MetasSemanalesTintoreria;
